"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _bind = _interopRequireDefault(require("classnames/bind"));

var _style = _interopRequireDefault(require("./style.css"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var REACT_ELEMENT_TYPE;

function _jsx(type, props, key, children) { if (!REACT_ELEMENT_TYPE) { REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol["for"] && Symbol["for"]("react.element") || 0xeac7; } var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = { children: void 0 }; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = new Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }

var cx = _bind["default"].bind(_style["default"]);

var Step = function Step(_ref) {
  var label = _ref.label,
      number = _ref.number,
      isActive = _ref.isActive,
      _ref$isInteractive = _ref.isInteractive,
      isInteractive = _ref$isInteractive === void 0 ? false : _ref$isInteractive,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function () {
    return void 0;
  } : _ref$onClick;
  return /*#__PURE__*/_jsx("div", {
    className: cx('xsui-step-tabs__item', isActive && 'xsui-step-tabs__item--active', disabled && 'xsui-step-tabs__item--disabled', isInteractive && 'xsui-step-tabs__item--interactive'),
    onClick: isInteractive ? onClick : function () {
      return void 0;
    }
  }, void 0, /*#__PURE__*/_jsx("div", {
    className: cx('xsui-step-tabs__item__number')
  }, void 0, number), /*#__PURE__*/_jsx("div", {
    className: cx('xsui-step-tabs__item__label')
  }, void 0, label));
};

var StepTabs = function StepTabs(_ref2) {
  var current = _ref2.current,
      steps = _ref2.steps,
      _ref2$isInteractive = _ref2.isInteractive,
      isInteractive = _ref2$isInteractive === void 0 ? false : _ref2$isInteractive;
  var extendedSteps = steps.map(function (step, index) {
    return _objectSpread(_objectSpread({}, step), {}, {
      number: index + 1,
      isActive: !step.disabled && current >= index + 1,
      isInteractive: isInteractive
    });
  });
  return /*#__PURE__*/_jsx("div", {
    className: cx('xsui-step-tabs')
  }, void 0, extendedSteps.map(function (step, index) {
    return /*#__PURE__*/_react["default"].createElement(Step, _extends({}, step, {
      key: "xsui-step---".concat(index)
    }));
  }));
};

var _default = StepTabs;
exports["default"] = _default;